import React, { useContext } from 'react';
import { Controller } from 'react-hook-form';
import get from 'lodash/get';
import { useTranslation } from 'next-i18next';
import { CoreContext } from './context/index.js';

const Checkbox = ({ control, errors, name, label = '', id = '', disabled, }) => {
    const { t } = useTranslation('');
    const { data: { siteConfig: { siteName = '' } = {} }, } = useContext(CoreContext);
    const errorText = get(errors, `${name}.message`, '');
    const isError = Boolean(errorText);
    return (React.createElement(Controller, { control: control, name: name, render: ({ field: { value, onChange } }) => (React.createElement("div", { className: "input-container checkbox-container", id: id, "data-testid": id },
            React.createElement("div", { className: "form-control-wrapper checkbox-wrapper" },
                React.createElement("label", { className: "label" },
                    React.createElement("input", { "data-testid": name, type: "checkbox", className: "checkbox", checked: value, disabled: disabled, onKeyDown: (e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                e.stopPropagation();
                                onChange(!value);
                            }
                        }, onChange: () => onChange(!value) }),
                    label)),
            isError && (React.createElement("div", { className: "error", role: "alert" }, t(errorText, { siteName }))))) }));
};

export { Checkbox as C };
//# sourceMappingURL=Checkbox-o9DWtxXo.js.map
